import React, { useMemo } from 'react';
import { Box, useTexture } from '@react-three/drei';
import { ModelProps } from '../scene/react-three-components/sceneAsset';
import { STUDIO_ID_SUFFIX } from '../../../util/constants';

const ErrorBox = (props: ModelProps) => {
  const { asset, position, scale, rotation, instanceId } = props;
  const errorTextureURL =
    'https://d23hwblhugcea5.cloudfront.net/studioAssets/miscAssets/errorImg.jpg';
  const texture = useTexture(errorTextureURL);
  return (
    <Box
      ref={asset.ref}
      key={`asset-${asset.name}-${instanceId}`}
      position={position ? position : [0, 0, 0]}
      scale={scale ? scale : [1, 1, 1]}
      rotation={rotation ? rotation : [0, 0, 0]}
      name={`${asset.name}${STUDIO_ID_SUFFIX}${instanceId}`}
      args={[1, 1, 1]}
    >
      <meshStandardMaterial color='white' map={texture} />
    </Box>
  );
};

type ModelErrorHandleState = {
  hasError: boolean;
};

export class ModelErrorHandler extends React.Component<
  any,
  ModelErrorHandleState
> {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    console.log(error);
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.log(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <ErrorBox {...(this.props as ModelProps)} />;
    }

    return this.props.children;
  }
}
